/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { StyledIcon, StyledTypography } from "@insite/mobius/Link";
import LinkPresentationPropsDefault from "@insite/mobius/Link/presentationProps";
import getColor from "@insite/mobius/utilities/getColor";
import { xBaseTheme } from "@monsma/XDL/types";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...LinkPresentationPropsDefault,
        color: "common.ui2",
        typographyProps: {
            weight: 600,
            size: "12px",
            lineHeight: "15px",
        },
        hoverStyle: {
            color: "#488FEB", // The hover can not read our "common.ui3" style
        },
        css: css`
            &:disabled,
            &[disabled] {
                opacity: 0.33;
                cursor: not-allowed;
            }

            ${({ iconColor }: any) => {
                return css`
                    &:hover {
                        [class^="IconWrapper"] {
                            color: ${getColor(iconColor)};
                        }
                    }
                `;
            }}
          
            &, ${/* sc-selector */ StyledIcon}, ${/* sc-selector */ StyledTypography} {
                transition: all 0.2s linear;
            }
        `,
    },
} as xBaseTheme["link"];
